export enum enumEntityModelCode {
  IMPORTER = 'IM',
  CONSIGNEE = 'CN',
  BUYER = 'BY',
  SHIP_TO = 'ST',
  SELLER = 'SE',
  MANUFACTURER = 'MF',
  CONSOLIDATOR = 'CS',
  STAFFING_LOCATION = 'LG',
  TRUCKER = 'TR',
  ABI_CLIENT = 'ABI',

  SHIP = 'VL',
  BOND = 'BN',
  HTS = 'HTS',
  PM = 'PM',

  NOTIFY_PARTY = 'NP',
  SHIPPER = 'SH',
  FORWARDING_AGENT = 'FA',
  DELIVERY_AGENT = 'DA',
  ISSUER = 'IS',

  BILL_TO = 'BT',
}
